import { Badge } from '@flote/ui';
import { Package, Truck, Link } from 'lucide-react';
import type { DeliveryTaskType } from '@flote/types/delivery';

interface TaskTypeBadgeConfig {
  label: string;
  className: string;
  Icon: React.ComponentType<{ className?: string }>;
}

const TASK_TYPE_CONFIG: Record<DeliveryTaskType, TaskTypeBadgeConfig> = {
  pickup: {
    label: 'Pickup',
    className: 'bg-purple-100 text-purple-800 border-purple-200 hover:bg-purple-100',
    Icon: Package,
  },
  dropoff: {
    label: 'Dropoff',
    className: 'bg-sky-100 text-sky-800 border-sky-200 hover:bg-sky-100',
    Icon: Truck,
  },
};

interface TaskTypeBadgeProps {
  taskType: DeliveryTaskType;
  linkedTaskId?: string;
  className?: string;
}

export function TaskTypeBadge({ taskType, linkedTaskId, className }: TaskTypeBadgeProps) {
  const config = TASK_TYPE_CONFIG[taskType] ?? {
    label: taskType,
    className: 'bg-gray-100 text-gray-800 border-gray-200',
    Icon: Truck,
  };

  const { Icon } = config;

  return (
    <div className="flex items-center gap-1">
      <Badge className={`${config.className} ${className ?? ''} flex items-center gap-1`}>
        <Icon className="h-3 w-3" />
        {config.label}
      </Badge>
      {linkedTaskId && (
        <span title="Linked task" className="text-muted-foreground">
          <Link className="h-3 w-3" />
        </span>
      )}
    </div>
  );
}
